module.exports = __webpack_public_path__ + "media/src/images/page03_zu_worksheet-28a28e31e43cfd35617e4d624332be8d.gif";